import React from "react";
import { twMerge } from "tailwind-merge";
import { HostThemePreviewShell } from "../../lib/hostThemePreview";

/**
 * Demo pages share the same host-theme preview shell as Home / feed,
 * so cycling Midnight Groove (etc.) carries into demo event cards and heroes.
 */
export default function DemoThemedShell({ className = "", children }) {
  return (
    <HostThemePreviewShell
      className={twMerge("min-h-screen bg-canvas text-ink font-body", className)}
    >
      {children}
    </HostThemePreviewShell>
  );
}
